import React, { useEffect, useState } from "react";

const Home = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const mobileVideo = `${process.env.PUBLIC_URL}/img/acceuil/acceuilT.mp4`;
  const desktopVideo = `${process.env.PUBLIC_URL}/img/acceuil/acceuil3.mp4`;

 

  return (
    <div className="home-container">
      <video
        playsInline
        autoPlay
        loop
        muted
        key={isMobile ? "mobile" : "desktop"} // Force React à recharger la vidéo
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      >
        <source src={isMobile ? mobileVideo : desktopVideo} type="video/mp4" />
      </video>
    </div>
  );
};

export default Home;
